import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PmIconComponent, PmLinkComponent } from '@libs/ui';
import { ToolCallStatus, type ToolCallLine } from '../../models/chat';
import { LucideWrench } from '@lucide/angular';

@Component({
  selector: 'pm-chat-tool-calls',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (toolCalls().length === 1) {
      <span
        class="inline-flex items-center gap-1.5 text-sm leading-[1.3] text-content-subdued"
      >
        @if (toolCalls().at(0)?.status === ToolCallStatus.Calling) {
          {{
            'chat.toolCall.calling'
              | translate: { name: toolCalls().at(0)?.name }
          }}
        } @else {
          <pm-icon [icon]="LucideWrench" size="sm" />
          {{
            'chat.toolCall.called'
              | translate: { name: toolCalls().at(0)?.name }
          }}
        }
      </span>
    } @else {
      <pm-link
        size="normal"
        [icon]="LucideWrench"
        [text]="
          'chat.toolCall.quantity' | translate: { quantity: toolCalls().length }
        "
        (handleClick)="toggle()"
      />
      @if (expanded()) {
        <ul
          class="m-0 flex list-none flex-col gap-0.5 p-0 pl-[23px]"
          role="status"
          aria-live="polite"
        >
          @for (call of toolCalls(); track call.id) {
            <li
              class="inline-flex items-center gap-1.5 text-sm leading-[1.3] text-content-subdued"
            >
              @if (call.status === ToolCallStatus.Calling) {
                {{ 'chat.toolCall.calling' | translate: { name: call.name } }}
              } @else {
                {{ call.name }}
              }
            </li>
          }
        </ul>
      }
    }
  `,
  imports: [TranslatePipe, PmIconComponent, PmLinkComponent],
})
export class ChatToolCallsComponent {
  readonly toolCalls = input.required<ToolCallLine[]>();
  protected readonly ToolCallStatus = ToolCallStatus;

  protected readonly LucideWrench = LucideWrench;

  protected readonly expanded = signal(false);

  protected toggle(): void {
    this.expanded.update((value) => !value);
  }
}
